import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@psspl/utils';
const SIZE_CLASS = {
    sm: 'size-3.5 border-2',
    md: 'size-5 border-2',
    lg: 'size-7 border-[3px]',
};
export function Spinner({ size = 'md', label = 'Loading', className, ...rest }) {
    return (_jsx("span", { role: label.length === 0 ? 'presentation' : 'status', "aria-live": label.length === 0 ? undefined : 'polite', className: cn('inline-block shrink-0 animate-spin rounded-full border-current border-t-transparent', SIZE_CLASS[size], className), ...rest, children: _jsx("span", { className: "sr-only", children: label }) }));
}
//# sourceMappingURL=spinner.js.map